import { Injectable } from '@angular/core';
import {
  Http,
  Response,
  RequestOptions,
  RequestOptionsArgs,
  Headers
} from '@angular/http';

import { RestService } from './rest.service';
// Import RxJs required methods
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router';

@Injectable()
export class LoginService {
  userToken: String;
  invalidLogin: boolean;
  companyName: String;

  constructor(
    private http: Http,
    private restService: RestService,
    private router: Router
  ) {
    this.userToken = null;
    this.invalidLogin = false;
  }

  login(_username: String, _password: String): Observable<Response> {
    const endpoint = this.restService.endPoints.LOGIN;
    // const bodyString = JSON.stringify(`{"username":"${username}", "password":"${password}"}`); // Stringify payload
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers }); // C

    return this.http
      .post(
        endpoint.getUrl(),
        { username: _username, password: _password },
        options
      )
      .map((res: Response) => {
        const result = res.json();
        this.userToken = result.token;
        localStorage.setItem('companyName', result.companyName)
        this.router.navigate(['']);
        localStorage.setItem('userToken', result.token);
      })
      .catch(error => {
        if (error.status === 403) {
          this.invalidLogin = true;
        }
        return Observable.throw(error.json().error || 'Server error');
      });

  }
  isInvalidLogin(): boolean {
    return this.invalidLogin;
  }

  logout(): void {
    localStorage.removeItem('userToken');
    localStorage.removeItem('companyName');
    this.router.navigate(['login']);
  }

  isLoggedIn(): boolean {
    return this.getUserToken() != null;
  }

  getUserToken(): String {
    return localStorage.getItem('userToken');
  }

  getCompanyName(): String {
    return this.companyName;
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/services/login.service.ts